import {toggleModal} from "./toggleModalActions";

export const getWeatherStationsPending = () => {
    return {
        type: 'GET_WEATHER_STATIONS_PENDING'
    }
};

export const getWeatherStationsSuccess = (stations, page, pageCount, itemsCount) => {
    return {
        type: 'GET_WEATHER_STATIONS_SUCCESS',
        stations,
        page,
        pageCount,
        itemsCount
    }
};

export const getWeatherStationsError = error => {
    return {
        type: 'GET_WEATHER_STATIONS_ERROR',
        error: error
    }
};

export const addWeatherStationSuccess = () => {
    return {
        type: 'ADD_WEATHER_STATION_SUCCESS'
    }
};

export const addWeatherStationError = error => {
    return {
        type: 'ADD_WEATHER_STATION_ERROR',
        error: error
    }
};


export const getWeatherStations = (page, numberPerPage, search, rimOnly) => {
    const pageNumber = page ? page : 1;
    // const filterValue = filter ? filter : 'ALL';
    const searchParam = search ? `&search_query=${encodeURIComponent(search)}` : '';
    const rimOnlyParam = `&rim_only=${rimOnly ? 'true' : 'false'}`;
    const numberOfRecords = numberPerPage ? numberPerPage : 3;

    return dispatch => {
        dispatch(getWeatherStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/weather_station_list?page=${pageNumber}&number_on_page=${numberOfRecords}${searchParam}${rimOnlyParam}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getWeatherStationsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getWeatherStationsSuccess(res.weatherStations, res.page, res.pageCount, res.itemsCount))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteStation = (id) => {
    return dispatch => {
        dispatch(getWeatherStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/weather_station_delete/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWeatherStations());
                } else {
                    dispatch(getWeatherStationsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const addWeatherStation = data => {
    return dispatch => {
        dispatch(getWeatherStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/create_weather_station`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addWeatherStationSuccess());
                    dispatch(getWeatherStations(1))
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(getWeatherStationsError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const editWeatherStation = (data) => {
    return dispatch => {
        dispatch(getWeatherStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_weather_station`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWeatherStations(1))
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(getWeatherStationsError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}


export const selectWeatherStation = (station, page) => {
    return {
        type: 'SELECT_WEATHER_STATION',
        selected: { station: station, page }
    };
};

export const setWeatherStationsFilters = filters => {
    return {
        type: 'SET_WEATHER_STATIONS_FILTERS',
        filters: filters
    }
};
